<template>
    <header class="custom_header">
        <div v-if="impersonating" class="impersonation-banner" data-testid="impersonation-banner">
            <strong>Impersonace:</strong>
            {{ originalFullname }} pracuje jako {{ userFullname }}.
            <button
                type="button"
                class="btn btn-sm btn-light ml-2"
                data-testid="stop-impersonation"
                :disabled="stoppingImpersonation"
                @click="stopImpersonation"
            >Vrátit se k původnímu uživateli</button>
            <span v-if="impersonationError" class="ml-2">{{ impersonationError }}</span>
        </div>
        <div class="app-header navbar justify-content-between" v-if="userFullname">

            <b-link class="navbar-brand" to="#">clinico</b-link>

            <!--<ol class="breadcrumb">
                <li class="breadcrumb-item" v-for="(item, index) in list">
                    <span class="active" v-if="isLast(index)">{{ showName(item) }}</span>
                    <router-link :to="item" v-else>{{ showName(item) }}</router-link>
                </li>
            </ol>-->

            <ul class="navbar-nav">
                <li class="nav-item">
                    <router-link :to="{ name: 'Home'}" v-if="$route.name !== 'Home'"><i class="fa fa-home fa-2x" aria-hidden="true"></i></router-link>
                    <i class="fa fa-home fa-2x text-secondary" aria-hidden="true" v-else=""></i>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'Result'}" v-if="$route.name !== 'Result'" data-testid="nav-lab-results"><i class="fa fa-flask fa-2x" aria-hidden="true"></i></router-link>
                    <i class="fa fa-flask fa-2x text-secondary" aria-hidden="true" v-else=""></i>
                </li>
                <!-- <li class="nav-item">
                    <router-link :to="{ name: 'Task'}" v-if="$route.name !== 'Task'"><i class="fa fa-check-square-o fa-2x" aria-hidden="true"></i></router-link>
                    <i class="fa fa-check-square-o fa-2x text-secondary" aria-hidden="true" v-else=""></i>
                </li> -->
                <li class="nav-item">
                    <router-link :to="{ name: 'Calendar'}" v-if="$route.name !== 'Calendar'" data-testid="nav-calendar"><i class="fa fa-calendar fa-2x" aria-hidden="true"></i></router-link>
                    <i class="fa fa-calendar fa-2x text-secondary" aria-hidden="true" v-else=""></i>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'ClientRegistration'}" v-if="$route.name !== 'ClientRegistration'" data-testid="nav-register-client"><i class="fa fa-user-plus fa-2x" aria-hidden="true"></i></router-link>
                    <i class="fa fa-user-plus fa-2x text-secondary" aria-hidden="true" v-else=""></i>
                </li>
                <li class="nav-item" v-if="hasRole('manager')">
                    <router-link :to="{ name: 'ContractualReporting'}" v-if="$route.name !== 'ContractualReporting'" data-testid="nav-contractual-reporting"><i class="fa fa-coins fa-2x" aria-hidden="true"></i></router-link>
                    <i class="fa fa-coins fa-2x text-secondary" aria-hidden="true" v-else=""></i>
                </li>
                <li class="nav-item" v-if="hasRole('analyst')">
                    <router-link :to="{ name: 'Statistic'}" v-if="$route.name !== 'Statistic'" data-testid="nav-statistics"><i class="fa fa-chart-line fa-2x" aria-hidden="true"></i></router-link>
                    <i class="fa fa-chart-line fa-2x text-secondary" aria-hidden="true" v-else=""></i>
                </li>
            </ul>

            <div class="col-md-4">
                <multiselect v-model="selected" :reset-after="true" id="search" data-testid="client-search" label="label" track-by="code" placeholder="vyhledat klienta" open-direction="bottom" :options="clients" :multiple="false" :searchable="true" :internal-search="false" :close-on-select="true" :options-limit="300" :limit="3" :max-height="600" :show-no-results="false" @search-change="getResult" @select="openClient" :clear-on-select="true" selectLabel="">
                    <template slot="option" scope="props">
                        <div class="option__desc" data-testid="client-search-option">
                            <span class="option__title" :class="props.option.available === true ? 'available' : 'unavailable'">
                                <div class="row m-0 pb-1">
                                    <div class="col-sm-6" data-testid="client-search-option-name">{{ props.option.full_name_reversed }}</div>
                                    <div class="col-sm-6 text-right" data-testid="client-search-option-pin">{{ props.option.pin_in_bd }}</div>
                                </div>
                                <div class="row m-0 font-sm">
                                    <div class="col-sm-12">
                                        <span>{{ props.option.default_email_address }}</span>
                                        <span>{{ props.option.default_phone_number }}</span>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </template>
                </multiselect>
            </div>

            <!-- <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button> -->

                <!--
            <router-link :to="{ name: 'ClientRegistration' }" tag="button" class="btn btn-primary btn-sm"><i class="fa fa-user-plus" aria-hidden="true"></i> Registrovat klienta</router-link>
                -->
            <!-- <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarMinimize">&#9776;</button> -->
            <span class=""><span data-testid="medic-name">{{ userFullname }}</span><i @click="authLock" class="navbar-toggler fa fa-lock" aria-hidden="true"></i><i @click="authLogout" data-testid="logout" class="navbar-toggler fa fa-sign-out" aria-hidden="true"></i></span>

        </div>
        <div class="app-header navbar second_row" data-testid="client-banner" v-if="isAuthenticated && client">
            <div class="d-flex justify-content-between w-100 align-items-center">
                <div class="">
                    <client-detail :client="client" @reload-client="reloadClient"></client-detail>

                    <client-insurance :client="client" @reload-client="reloadClient"></client-insurance>

                    <client-membership :client="client" @reload-client="reloadClient"></client-membership>

                    <span class="separator">|</span>

                    <client-address :client="client" @reload-client="reloadClient"></client-address>

                    <span class="separator">|</span>

                    <client-email-address :client="client" @reload-client="reloadClient"></client-email-address>
                    <!-- <span><i class="fa fa-envelope-square" aria-hidden="true"></i> jakubzelenka@seznam.cz</span>-->

                    <span class="separator">|</span>

                    <client-phone-number :client="client" @reload-client="reloadClient"></client-phone-number>

                    <span class="separator">|</span>

                    <client-gdpr-consent :client="client" @reload-client="reloadClient"></client-gdpr-consent>

                    <span class="separator">|</span>

                    <router-link class="text-secondary" :to="{ name: 'ShowClient', params: { clientid: client.id }}"><i class="fa fa-address-card-o" aria-hidden="true"></i></router-link>

                    <a class="text-secondary" data-testid="client-banner-log" @click="showModalClientLog"> <i class="fa fa-history" aria-hidden="true"></i></a>

                    <a class="text-secondary" target="_blank" :href="setting.hostname + 'client/' + client.id + '/label/pdf'"> <i class="fa fa-tag" aria-hidden="true"></i></a>

                    <br>
                    <client-p-s-a :client="client" @reload-client="reloadClient"></client-p-s-a>
                    <template v-if="editingClientNote === true">
                        <form class="form-inline" @submit.prevent="saveClient()">
                            <label for="note">poznámka: </label>
                            <input v-model="client.note" type="text" class="form-control ml-sm-1 mr-sm-2 col-sm-4" aria-describedby="noteHelp" id="note" data-testid="client-banner-note-input">
                            <button v-if="!waitForSave" type="submit" class="btn btn-primary" data-testid="client-banner-note-save">Uložit</button>
                            <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                        </form>
                    </template>
                    <template v-else="">
                        <button @click="editNote" class="btn btn-sm btn-link text-secondary" data-testid="client-banner-note-edit"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                            <i v-if="client.note">Poznámka: </i><span data-testid="client-banner-note">{{ client.note }}</span>
                    </template>
                </div>
                <div class="">
                    <client-auth :client="client" @reload-client="reloadClient"></client-auth>
                </div>
            </div>
        </div>

        <client-log :opened="modalClientLogOpened" :clientId="client.id"></client-log>
    </header>
</template>
<script>
  import apiMixin from '@/mixins'

  import ClientSelectInsurance from '@/views/Client/components/ClientSelectInsurance.vue'
  import ClientInsurance from '@/views/Client/components/ClientInsurance.vue'
  import ClientMembership from '@/views/Client/components/ClientMembership.vue'
  import ClientPSA from '@/views/Client/components/ClientPSA.vue'
  import ClientAddress from '@/views/Client/components/ClientAddress.vue'
  import ClientGdprConsent from '@/views/Client/components/ClientGdprConsent.vue'
  import ClientEmailAddress from '@/views/Client/components/ClientEmailAddress.vue'
  import ClientPhoneNumber from '@/views/Client/components/ClientPhoneNumber.vue'
  import ClientDetail from '@/views/Client/components/ClientDetail.vue'
  import ClientAuth from '@/views/Client/components/ClientAuth.vue'
  import { clearStaffSession, stopImpersonating } from '@/services/staff-session'

  import ClientLog from '@/views/Client/modals/ClientLog.vue'
  import _ from 'lodash'

  // import { mapState } from 'vuex'

  export default {
    data () {
      return {
        setting: require('../variables.js'),
        selected: '',
        clients: [],
        clientsPending: false,
        clientsError: false,
        client: false,
        clientPending: false,
        clientError: false,
        clientDone: false,
        waitForSave: false,
        editingClientNote: false,
        clientForUpdate: '',
        modalClientLogOpened: false,
        clientId: false,
        stoppingImpersonation: false,
        impersonationError: ''
      }
    },
    props: {
      list: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    mixins: [apiMixin],
    name: 'header',
    methods: {
      stopImpersonation () {
        this.stoppingImpersonation = true
        this.impersonationError = ''
        stopImpersonating().then(() => {
          window.location.reload()
        }).catch(() => {
          this.impersonationError = 'Impersonaci se nepodařilo ukončit.'
          this.stoppingImpersonation = false
        })
      },
      editNote () {
        this.editingClientNote = true
      },
      saveClient () {
        this.clientForUpdate = JSON.parse(JSON.stringify(this.client, this.replacer))
        delete this.clientForUpdate['email_address']
        delete this.clientForUpdate['client_auth']
        delete this.clientForUpdate['phone_number']
        delete this.clientForUpdate['address']
        delete this.clientForUpdate['membership']
        delete this.clientForUpdate['gdpr_consent']
        this.clientForUpdate['citizenship'] = this.client.citizenship.id
        this.putClient(this.clientForUpdate)
        this.editingClientNote = false
      },
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      asideToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('aside-menu-hidden')
      },
      authLogout () {
        this.$http.post('logout', null, {emulateJSON: true}).then(response => {
          clearStaffSession()
          this.$ls.remove('token')
          this.$ls.remove('authenticated')
          this.$ls.remove('role')
          this.$ls.remove('fullname')
          this.$ls.remove('userid')
          this.$ls.remove('locked')
          this.$router.push({name: 'Login'})
        }).catch(error => {
          // console.log('chytam chybu')
          console.log(error)
          // this.loginError = error.response.data.errors
          // this.loginPending = false
        })
      },
      authLock () {
        // localStorage.setItem('locked', 'true')
        this.$ls.set('locked', true)
        this.$emit('lock')
        // this.auth_locked = true
        // window.location.reload()
      },
      openClient (value) {
        // console.log('oteviram klienta' + value.id)
        this.selected = ''
        this.$router.push({name: 'ShowClient', params: { clientid: value.id }})
      },
      getResult: _.debounce(function (text) {
        if (text.length > 2) {
          this.searchClients(text)
        }
      }, 600),
      // getResult (text) {
      //   // loading(true)
      //   if (text.length > 2) {
      //     this.searchClients(text)
      //   }
      // },
      isLast (index) {
        return index === this.list.length - 1
      },
      showName (item) {
        if (item.meta && item.meta.label) {
          item = item.meta && item.meta.label
        }
        if (item.name) {
          item = item.name
        }
        return item
      },
      reloadClient (val) {
        if (val === true) {
          this.getClient(this.client.id)
        }
      },
      showModal (name) {
        this.$modal.show(name)
      },
      showModalClientLog () {
        this.modalClientLogOpened = true
        this.showModal('client-log')
      }
    },
    computed: {
      userFullname () {
        return this.$ls.get('fullname')
      },
      isAuthenticated () {
        return this.$ls.get('authenticated')
      },
      impersonating () {
        return this.$ls.get('impersonating') === true
      },
      originalFullname () {
        return this.$ls.get('originalFullname')
      }
      /* clientId () {
        return this.$store.state.clientId
      } */
    },
    watch: {
      '$route' (to, from) {
        if (to.matched[1].name === 'ClientRegistration' && typeof (to.params.clientid) !== 'undefined') {
          this.getClient(to.params.clientid)
        } else if (typeof (to.params.clientid) !== 'undefined') {
          if (String(from.params.clientid) !== String(to.params.clientid)) {
            this.client = false
            this.getClient(to.params.clientid)
          } else if (from.matched[1].name === 'ClientRegistration' &&
            to.matched[1].name === 'ShowClient' &&
            String(from.params.clientid) === String(to.params.clientid)) {
            this.getClient(to.params.clientid)
          }
        } else {
          this.client = false
        }
      },
      clientDone (val) {
        if (val === true) {
          // console.log('reloaduji cleinta')
          this.clientDone = false
          this.reloadClient(true)
        }
      }
    },
    beforeMount () {
      if (typeof (this.$route.params.clientid) !== 'undefined') {
        this.getClient(this.$route.params.clientid)
      }
    },
    components: {
      ClientSelectInsurance,
      ClientInsurance,
      ClientMembership,
      ClientAddress,
      ClientEmailAddress,
      ClientPhoneNumber,
      ClientDetail,
      ClientAuth,
      ClientLog,
      ClientPSA,
      ClientGdprConsent
    }
  }
</script>

<style scoped>
  .impersonation-banner {
    position: relative;
    z-index: 1100;
    padding: 0.6rem 1rem;
    color: #3f1d00;
    background: #ffca3a;
    border-bottom: 3px solid #b45309;
    text-align: center;
  }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .navbar .dropdown-toggle {
        padding: 0;
    }

    .custom_header {
        position: fixed;
        z-index: 1020;
        width: 100%;
    }

    .app-header {
        position: relative !important;

    }

    ol.breadcrumb {
        border: none !important;
        margin: 0 !important;
        padding: 0 0 0 1rem !important;
    }

    .second_row {
        min-height: 55px !important;
        height: auto !important;
        padding: 0 1rem !important;
        z-index: 1019;
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue?12b21a58